import { useState } from 'react';
import { IntroductionStep } from './IntroductionStep';
import { EnterAddress } from './EnterAddress';
import { Success } from './Success';

interface FlowOnboardingProps {
    onComplete: () => void;
}

export const FlowOnboarding = ({ onComplete }: FlowOnboardingProps) => {
    const [currentStep, setCurrentStep] = useState(1);

    const handleIntroComplete = () => {
        setCurrentStep(2);
    };

    const handleAddressComplete = () => {
        setCurrentStep(3);
    };

    const handleSuccessComplete = () => {
        onComplete();
    };

    return (
        <div className='flex min-h-full w-full flex-col items-center justify-center overflow-y-auto'>
            {currentStep === 1 && <IntroductionStep onComplete={handleIntroComplete} />}
            {currentStep === 2 && <EnterAddress onComplete={handleAddressComplete} />}
            {currentStep === 3 && <Success onComplete={handleSuccessComplete} />}
        </div>
    );
};
